import { css } from '@/styled-system/css';

export const heroContainerStyles = css.raw({
  marginRight: 'auto',
  marginLeft: 'auto',
  textAlign: 'left',
  xl: {
    // oxlint-disable-next-line constellation/no-raw-spacing-values
    maxWidth: '511px',
    // oxlint-disable-next-line constellation/no-raw-spacing-values
    minWidth: '300px',
    // oxlint-disable-next-line constellation/no-raw-spacing-values
    flexBasis: '300px',
    flexGrow: 1,
    marginRight: '0',
    marginLeft: '0',
  },
});

export const infoContainerStyles = css.raw({
  textAlign: 'left',
  height: 'fit-content',
});
